import { render, staticRenderFns } from "./AuditLogs.vue?vue&type=template&id=c85e6a0a&scoped=true"
import script from "./AuditLogs.vue?vue&type=script&lang=js"
export * from "./AuditLogs.vue?vue&type=script&lang=js"
import style0 from "./AuditLogs.vue?vue&type=style&index=0&id=c85e6a0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85e6a0a",
  null
  
)

export default component.exports